'use strict';
/**
 * Convert a JavaScript date into an `RFC3339Nano` formatted
 * string.
 *
 * @param {Date} time
 */

module.exports.toRFC3339 = function (time) {
  var year = time.getUTCFullYear();
  var month = String(time.getUTCMonth() + 1).padStart(2, '0');
  var day = String(time.getUTCDate()).padStart(2, '0');
  var hour = String(time.getUTCHours()).padStart(2, '0');
  var minute = String(time.getUTCMinutes()).padStart(2, '0');
  var seconds = String(time.getUTCSeconds()).padStart(2, '0');
  var milliseconds = time.getUTCMilliseconds();
  var nanoseconds = milliseconds * 1000 * 1000;
  return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minute, ":").concat(seconds, ".").concat(nanoseconds, "Z");
};
/**
 * Parses a date string formatted as `RFC3339Nano` into a
 * JavaScript Date object.
 *
 * @param {string} time
 */


module.exports.parseRFC3339 = function (time) {
  var rfc3339Matcher = new RegExp( // 2006-01-02T
  '(\\d{4})-(\\d{2})-(\\d{2})T' + // 15:04:05
  '(\\d{2}):(\\d{2}):(\\d{2})' + // .999999999Z
  '\\.(\\d+)Z');
  var m = String(time).trim().match(rfc3339Matcher);

  if (!m) {
    throw new Error('Invalid format');
  }

  var year = parseInt(m[1], 10);
  var month = parseInt(m[2], 10) - 1;
  var date = parseInt(m[3], 10);
  var hour = parseInt(m[4], 10);
  var minute = parseInt(m[5], 10);
  var second = parseInt(m[6], 10);
  var millisecond = parseInt(m[7].slice(0, -6), 10);
  return new Date(Date.UTC(year, month, date, hour, minute, second, millisecond));
};